module.exports = __webpack_public_path__ + "img/18.6c648852.png";